import { render } from "./HscrollAlt.vue?vue&type=template&id=0d717b04"
import script from "./HscrollAlt.vue?vue&type=script&lang=js"
export * from "./HscrollAlt.vue?vue&type=script&lang=js"

import "./HscrollAlt.vue?vue&type=style&index=0&id=0d717b04&lang=css"
script.render = render

export default script